import Link from "next/link";
import { useRouter } from "next/router";
import { useOnboarding } from "@models/interactions/use-onboarding";
import classNames from "classnames";

export function useLegalTap() {
  const route = useRouter();
  useOnboarding();

  const selectedTab = (tab: string) => route.asPath.split("/").at(-1) === tab;

  return {
    models: {
    },
    operations: {
      selectedTab
    },
  };
}

export default function LegalTap() {
  const { operations: { selectedTab }, models } = useLegalTap();

  return(
    <nav className="w-full justify-center">
      <ul className="w-full flex flex-col md:flex-row pt-5 items-center justify-center">
        <Link 
          href={"/legal/privacy-policy"} 
          className={classNames("w-[256px] h-11 md:w-[147px] text-memod-label px-6 py-3 flex justify-center items-center leading-base",
            { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("privacy-policy") }
        )}>
          Privacy Policy
        </Link>
        <Link 
          href={"/legal/terms-of-service"} 
          className={classNames("w-[256px] h-11 md:w-[166px] text-memod-label px-6 py-3 flex justify-center items-center leading-base",
            { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("terms-of-service") }
          )}
        >
          Terms of Service
        </Link>
        <Link 
          href={"/legal/core-program-terms-of-use"} 
          className={classNames("w-[256px] h-11 md:w-[246px] text-memod-label px-6 py-3 flex justify-center items-center leading-base",
          { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("core-program-terms-of-use") }
        )}>
          Core Program Terms Of Use
        </Link>
        <Link 
          href={"/legal/end-user-license-agreement"} 
          className={classNames("w-[256px] h-11 md:max-w-full text-memod-label px-6 py-3 flex justify-center items-center leading-base",
          { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("end-user-license-agreement") }
        )}>
          End-User License Agreement
        </Link>
        <Link 
          href={"/legal/cookies-policy"} 
          className={classNames("w-[256px] md:w-[154px] h-11 text-memod-label px-6 py-3 flex justify-center items-center leading-base",
          { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("cookies-policy") }
        )}>
          Cookies Policy
        </Link>
        <Link 
          href={"/legal/copyright-policy"} 
          className={classNames("w-[256px] md:w-[168px] h-11 text-memod-label px-6 py-3 flex justify-center items-center leading-base",
          { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("copyright-policy") }
        )}>
          Copyright Policy
        </Link>
        <Link 
          href={"/legal/monetization-terms"} 
          className={classNames("w-[256px] md:w-[191px] h-11 text-memod-label px-6 py-3 flex justify-center items-center leading-base",
          { "!text-white bg-[#3a3a3c] rounded-[30px]": selectedTab("monetization-terms") }
        )}>
          Monetization Terms
        </Link>
      </ul>
    </nav>
  );
}